import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const MyTime = lazyRouteComponent(() => import('@/_instructor/my-time'));

export const Route = createFileRoute('/_instructor/my-time')({
  component: () => renderInstructorPage(MyTime),
});
